export function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((cookie) => cookie.split('=')[0] === name)
    ?.split('=')[1];
}

export function setCookie(name, value, days = 10000) {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
}
